// import React, { useState } from "react";
// import { Eye, EyeOff, X } from "lucide-react";
// import { toast } from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { API_URLS } from "../../api/apiUrls";
// import { postApi } from "../../api/api_instance";
// import { CheckOutlined } from "@ant-design/icons";
// import { Modal } from "antd";
// import PopupCard from "./PopupCard";
// const SignupC = ({ onCloseSignupC, onLogin }) => {
//   const navigate = useNavigate();
//   const [signUpData, setSignUpData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     otp: "",
//     retypePassword: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [showRetypePassword, setShowRetypePassword] = useState(false);
//   const [showOTP, setShowOTP] = useState(false);
//   const [acceptAllTerms, setAcceptAllTerms] = useState(false);
//   const [isCodeSent, setIsCodeSent] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setSignUpData({ ...signUpData, [name]: value });
//   };

//   const handleSendCode = async () => {
//     if (signUpData.email) {
//       try {
//         const response = await postApi(
//           {
//             apiUrl: API_URLS.OTP_EMAIL,
//             data: { email: signUpData.email },
//           },
//           false,
//         );

//         if (response.success) {
//           // toast.success("Verification code sent to your email!");
//           // Modal.success({
//           //   icon: null,
//           //   centered: true,
//           //   closable: true,
//           //   className: "custom-success-modal",
//           //   okButtonProps: { style: { display: "none" } }, // 👈 Hide OK button
//           //   content: (
//           //     <div className="flex flex-col items-center text-center p-4">
//           //       <div className="bg-slate-300 p-2 rounded-full">
//           //         {" "}
//           //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
//           //       </div>

//           //       <h2 className="text-xl font-semibold text-[#000000] mb-2">
//           //        Verification code sent to your email!
//           //       </h2>
//           //     </div>
//           //   ),
//           // });
//           // setTimeout(() => {
//           //   Modal.destroyAll();
//           //   // onClose();
//           // }, 2000);
//           // setIsCodeSent(true);

//           setShowPopup(true); // Show your custom popup

//           setTimeout(() => {
//             setShowPopup(false); // Auto-close after 2s (like Modal.destroyAll)
//           }, 700000);

//           setIsCodeSent(true);

//         }

//         else {
//           // toast.error(response.message || "Failed to send code.");
//           Modal.success({
//             icon: null,
//             centered: true,
//             closable: true,
//             className: "custom-success-modal",
//             okButtonProps: { style: { display: "none" } }, // 👈 Hide OK button
//             content: (
//               <div className="flex flex-col items-center text-center p-4">
//                 <div className="bg-slate-300 p-2 rounded-full">
//                   {" "}
//                   <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
//                 </div>

//                 <h2 className="text-xl font-semibold text-[#000000] mb-2">
//                   {response.message}
//                 </h2>
//               </div>
//             ),
//           });
//           setTimeout(() => {
//             Modal.destroyAll();
//             // onClose();
//           }, 2000);
//         }
//       } catch (error) {
//         toast.error("Failed to send verification code.");
//       }
//     } else {
//       toast.error("Please enter your email first");
//     }
//   };

//   const handleSignUp = async (e) => {
//     e.preventDefault();

//     if (!signUpData.name.trim()) {
//       toast.error("Please enter your organisation name.");
//       return;
//     }

//     const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!emailPattern.test(signUpData.email)) {
//       toast.error("Please enter a valid email.");
//       return;
//     }

//     if (signUpData.password.length < 8) {
//       toast.error("Password must be at least 8 characters long.");
//       return;
//     }

//     if (signUpData.password !== signUpData.retypePassword) {
//       toast.error("Passwords do not match.");
//       return;
//     }

//     if (!signUpData.otp) {
//       toast.error("Please enter the OTP.");
//       return;
//     }

//     if (!acceptAllTerms) {
//       toast.error("Please accept the terms and conditions.");
//       return;
//     }

//     try {
//       const response = await postApi(
//         {
//           apiUrl: API_URLS.SIGN_UP_CLIENT,
//           data: signUpData,
//         },
//         false,
//       );

//       if (response.success) {
//         toast.success(response.message);
//         navigate("/login");
//       }
//     } catch (error) {
//       toast.error("Sign up failed. Please try again.");
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white py-4 px-6 shadow-lg rounded-lg sm:px-10 w-full max-w-md relative">
//         <button
//           onClick={onCloseSignupC}
//           className="absolute right-3 text-gray-500 hover:text-gray-700"
//         >
//           <X className="w-5 h-5" />
//         </button>

//         <h2 className="text-center text-2xl font-bold text-[#06513D] mb-1">
//           CARBURN
//         </h2>
//         <p className="text-center text-sm text-gray-600 mb-2">
//           Carbon Footprint & ESG Reporting
//         </p>

//         <form className="space-y-2" onSubmit={handleSignUp}>
//           {/* Organisation Name */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Organisation Name
//             </label>
//             <input
//               type="text"
//               name="name"
//               required
//               className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
//               placeholder="Enter organisation name"
//               value={signUpData.name}
//               onChange={handleChange}
//             />
//           </div>

//           {/* Email and Send Code */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email Address
//             </label>
//             <div className="relative">
//               <input
//                 type="email"
//                 name="email"
//                 required
//                 className="block w-full px-3 py-2 pr-28 border border-gray-300 rounded-md text-sm"
//                 placeholder="your@email.com"
//                 value={signUpData.email}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={handleSendCode}
//                 disabled={isCodeSent}
//                 className="absolute top-1/2 right-0 h-full transform -translate-y-1/2 bg-[#06513D] text-white text-xs px-3 py-1 rounded-md"
//               >
//                 {isCodeSent ? "Code Sent" : "Send Code"}
//               </button>
//             </div>
//           </div>

//           {/* OTP */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Verification Code
//             </label>
//             <div className="relative">
//               <input
//                 type={showOTP ? "text" : "password"}
//                 name="otp"
//                 required
//                 className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
//                 placeholder="••••••••"
//                 value={signUpData.otp}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowOTP(!showOTP)}
//                 className="absolute inset-y-0 right-0 pr-3 flex items-center"
//               >
//                 {showOTP ? (
//                   <EyeOff className="h-4 w-4 text-gray-400" />
//                 ) : (
//                   <Eye className="h-4 w-4 text-gray-400" />
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Password */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Password
//             </label>
//             <div className="relative">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 required
//                 className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
//                 placeholder="••••••••"
//                 value={signUpData.password}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 className="absolute inset-y-0 right-0 pr-3 flex items-center"
//               >
//                 {showPassword ? (
//                   <EyeOff className="h-4 w-4 text-gray-400" />
//                 ) : (
//                   <Eye className="h-4 w-4 text-gray-400" />
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Retype Password */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Retype Password
//             </label>
//             <div className="relative">
//               <input
//                 type={showRetypePassword ? "text" : "password"}
//                 name="retypePassword"
//                 required
//                 className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
//                 placeholder="••••••••"
//                 value={signUpData.retypePassword}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowRetypePassword(!showRetypePassword)}
//                 className="absolute inset-y-0 right-0 pr-3 flex items-center"
//               >
//                 {showRetypePassword ? (
//                   <EyeOff className="h-4 w-4 text-gray-400" />
//                 ) : (
//                   <Eye className="h-4 w-4 text-gray-400" />
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Terms */}
//           <div className="flex items-center text-xs text-gray-700">
//             <input
//               type="checkbox"
//               className="h-4 w-4 text-green-600 mr-2"
//               checked={acceptAllTerms}
//               onChange={(e) => setAcceptAllTerms(e.target.checked)}
//             />
//             Accept{" "}
//             <span className="ml-1 text-[#06513D]">
//               Term & Condition, Policies & terms of use
//             </span>
//           </div>

//           {/* Submit */}
//           <div>
//             <button
//               type="submit"
//               className="w-full py-2 mt-4 px-4 bg-[#06513D] text-white rounded-md shadow text-sm"
//             >
//               Sign Up
//             </button>
//           </div>
//         </form>

//         <div className="mt-6 text-center">
//           <p className="text-sm text-gray-600">
//             Already have an account?{" "}
//             <button
//               type="button"
//               onClick={onLogin}
//               className="font-medium text-[#06513D]"
//             >
//               Sign in
//             </button>
//           </p>
//         </div>
//       </div>
//       {showPopup && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//           <div className=" rounded-md shadow-md ">
//             <PopupCard
//               type="success"
//               title="Success"
//               message="Verification code sent to your email!"
//               buttons={[
//                 {
//                   label: "Close",
//                   onClick: () => setShowPopup(false),
//                   variant: "solid",
//                   bg: "bg-[#06513D]",
//                 },
//               ]}
//             />
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default SignupC;

// import React, { useState } from "react";
// import { Eye, EyeOff, X } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { API_URLS } from "../../api/apiUrls";
// import { postApi } from "../../api/api_instance";
// import { toast } from "react-hot-toast";
// import PopupCard from "./PopupCard";
// import { loginAsOrganisation, logout } from "../../redux/auth/authSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { CheckOutlined } from "@ant-design/icons";
// import { Modal } from "antd";
// const SignupC = ({ onCloseSignupC, onLogin }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [signUpData, setSignUpData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     otp: "",
//     retypePassword: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [showRetypePassword, setShowRetypePassword] = useState(false);
//   const [showOTP, setShowOTP] = useState(false);
//   const [acceptAllTerms, setAcceptAllTerms] = useState(false);
//   const [isCodeSent, setIsCodeSent] = useState(false);
//   const [isOtpVerified, setIsOtpVerified] = useState(false);
//   const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupData, setPopupData] = useState({
//     type: "success",
//     title: "Success",
//     message: "",
//   });

//    const handleVerifyOtp = async () => {
//     if (!signUpData.otp) {
//       return triggerPopup("error", "Error", "Please enter the OTP");
//     }

//     if (!signUpData.email) {
//       return triggerPopup("error", "Error", "Email is required");
//     }

//     setIsVerifyingOtp(true);

//     try {
//       const response = await postApi({
//         apiUrl: "api/auth/client/carburn/signup/verifyCarburnotp", // Using the endpoint you provided
//         data: {
//           OTP: signUpData.otp,
//           email: signUpData.email,
//         },
//       });

//       if (response.success) {
//         triggerPopup("success", "Success", "OTP verified successfully!");
//         setIsOtpVerified(true);
//       } else {
//         triggerPopup(
//           "error",
//           "Verification Failed",
//           response.message || "Invalid OTP. Please try again.",
//         );
//       }
//     } catch (error) {
//       triggerPopup("error", "Error", "Failed to verify OTP. Please try again.");
//     } finally {
//       setIsVerifyingOtp(false);
//     }
//   };

//   const triggerPopup = (type, title, message, duration = 5000) => {
//     setPopupData({ type, title, message });
//     setShowPopup(true);
//     setTimeout(
//       () => setShowPopup(false),

//       duration,
//     );
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setSignUpData({ ...signUpData, [name]: value });
//   };

//   const handleSendCode = async () => {
//     if (!signUpData.email) {
//       return triggerPopup("error", "Error", "Please enter your email first");
//     }

//     try {
//       const response = await postApi({
//         apiUrl: API_URLS.OTP_EMAIL,
//         data: { email: signUpData.email },
//       });

//       if (response.success) {
//         triggerPopup(
//           "success",
//           "Success",
//           "Verification code sent to your email!",
//         );
//         setIsCodeSent(true);
//       } else {
//         triggerPopup(
//           "error",
//           "Error",
//           response.message || "Failed to send code.",
//         );
//       }
//     } catch (error) {
//       triggerPopup("error", "Error", "Failed to send verification code.");
//     }
//   };

//   // Strong password validation function
//   const validatePassword = (password) => {
//     const minLength = 8;
//     const hasUpperCase = /[A-Z]/.test(password);
//     const hasLowerCase = /[a-z]/.test(password);
//     const hasNumbers = /\d/.test(password);
//     const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

//     if (password.length < minLength) {
//       return "Password must be at least 8 characters long.";
//     }
//     if (!hasUpperCase) {
//       return "Password must contain at least one uppercase letter.";
//     }
//     if (!hasLowerCase) {
//       return "Password must contain at least one lowercase letter.";
//     }
//     if (!hasNumbers) {
//       return "Password must contain at least one number.";
//     }
//     if (!hasSpecialChar) {
//       return "Password must contain at least one special character (@, #, $, %, etc.).";
//     }
//     return null; // Password is valid
//   };

//   // const handleSignUp = async (e) => {
//   //   e.preventDefault();

//   //   if (!signUpData.name.trim()) {
//   //     return triggerPopup(
//   //       "error",
//   //       "Error",
//   //       "Please enter your organisation name.",
//   //     );
//   //   }

//   //   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   //   if (!emailPattern.test(signUpData.email)) {
//   //     return triggerPopup("error", "Error", "Please enter a valid email.");
//   //   }

//   //   // Strong password validation
//   //   const passwordError = validatePassword(signUpData.password);
//   //   if (passwordError) {
//   //     return triggerPopup("error", "Error", passwordError);
//   //   }

//   //   if (signUpData.password !== signUpData.retypePassword) {
//   //     return triggerPopup("error", "Error", "Passwords do not match.");
//   //   }

//   //   if (!signUpData.otp) {
//   //     return triggerPopup("error", "Error", "Please enter the OTP.");
//   //   }

//   //   if (!acceptAllTerms) {
//   //     return triggerPopup(
//   //       "error",
//   //       "Error",
//   //       "Please accept the terms and conditions.",
//   //     );
//   //   }

//   //   try {
//   //     const response = await postApi({
//   //       apiUrl: API_URLS.SIGN_UP_CLIENT,
//   //       data: signUpData,
//   //     });

//   //     if (response.success) {
//   //       triggerPopup("success", "Success", response.message);
//   //         // onCloseSignupC();
//   //       // setTimeout(() => navigate("/login"), 2000);
//   //       //navigate("/organization/dashboard");
//   //     } else {
//   //       // Check if the error is specifically about incorrect OTP
//   //       if (response.message === "Incorrect OTP") {
//   //         triggerPopup(
//   //           "error",
//   //           "Invalid Code",
//   //           "The verification code you entered is incorrect"
//   //         );
//   //       } else {
//   //         // For other errors, use the original message
//   //         triggerPopup("error", "Error", response.message || "Sign up failed.");
//   //       }
//   //     }
//   //   } catch (error) {
//   //     triggerPopup("error", "Error", "Sign up failed. Please try again.");
//   //   }
//   // };

//   const handleSignUp = async (e) => {
//     e.preventDefault();

//     if (!signUpData.name.trim()) {
//       return triggerPopup(
//         "error",
//         "Error",
//         "Please enter your organisation name.",
//       );
//     }

//     const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!emailPattern.test(signUpData.email)) {
//       return triggerPopup("error", "Error", "Please enter a valid email.");
//     }

//     // Strong password validation
//     const passwordError = validatePassword(signUpData.password);
//     if (passwordError) {
//       return triggerPopup("error", "Error", passwordError);
//     }

//     if (signUpData.password !== signUpData.retypePassword) {
//       return triggerPopup("error", "Error", "Passwords do not match.");
//     }

//     if (!signUpData.otp) {
//       return triggerPopup("error", "Error", "Please enter the OTP.");
//     }

//     if (!acceptAllTerms) {
//       return triggerPopup(
//         "error",
//         "Error",
//         "Please accept the terms and conditions.",
//       );
//     }

//     try {
//       // First call signup API
//       const response = await postApi({
//         apiUrl: API_URLS.SIGN_UP_CLIENT,
//         data: signUpData,
//       });

//       if (response.success) {
//         triggerPopup("success", "Success", response.message);

//         // After successful signup, automatically call login API
//         try {
//           const loginResponse = await postApi(
//             {
//               apiUrl: API_URLS.LOGIN_CLIENT,
//               data: {
//                 email: signUpData.email,
//                 password: signUpData.password,
//               },
//             },
//             false,
//           );

//           if (loginResponse.success) {
//             const { user, token } = loginResponse.data;
//             dispatch(loginAsOrganisation({ user, token }));
//             navigate("/organization/dashboard");

//             // Modal.success({
//             //   icon: null,
//             //   centered: true,
//             //   closable: true,
//             //   className: "custom-success-modal",
//             //   okButtonProps: { style: { display: "none" } },
//             //   content: (
//             //     <div className="flex flex-col items-center text-center p-4">
//             //       <div className="bg-slate-300 p-2 rounded-full">
//             //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
//             //       </div>

//             //       <p className="text-[20px] mt-2 mb-1 font-medium text-[#06513D]">
//             //         Welcome to CARBURN!
//             //       </p>
//             //       <h2 className="text-sm font-semibold text-[#000000]">
//             //         Empowering your Net Zero journey
//             //       </h2>
//             //     </div>
//             //   ),
//             // });

//             setTimeout(() => {
//               Modal.destroyAll(); // Close all modals
//             }, 2000);
//           } else {
//             // Handle case when login response.success is false
//             toast.error(loginResponse.message || "Login failed after signup");
//           }
//         } catch (loginError) {
//           // Handle login API error
//           toast.error(
//             "Signup successful but login failed. Please login manually.",
//           );
//         }
//       } else {
//         // Check if the error is specifically about incorrect OTP
//         if (response.message === "Incorrect OTP") {
//           triggerPopup(
//             "error",
//             "Invalid Code",
//             "The verification code you entered is incorrect",
//           );
//         } else {
//           // For other errors, use the original message
//           triggerPopup("error", "Error", response.message || "Sign up failed.");
//         }
//       }
//     } catch (error) {
//       triggerPopup("error", "Error", "Sign up failed. Please try again.");
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white py-4 px-6 shadow-lg rounded-lg sm:px-10 w-full max-w-md relative">
//         <button
//           onClick={onCloseSignupC}
//           className="absolute right-3 text-gray-500 hover:text-gray-700"
//         >
//           <X className="w-5 h-5" />
//         </button>

//         <h2 className="text-center text-2xl font-bold text-[#06513D] mb-1">
//           CARBURN
//         </h2>
//         <p className="text-center text-sm text-gray-600 mb-2">
//           Carbon Footprint & ESG Reporting
//         </p>

//         <form className="space-y-2" onSubmit={handleSignUp}>
//           {/* Organisation Name */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Organisation Name
//             </label>
//             <input
//               type="text"
//               name="name"
//               className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
//               placeholder="Enter organisation name"
//               value={signUpData.name}
//               onChange={handleChange}
//             />
//           </div>

//           {/* Email and Send Code */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email Address
//             </label>
//             <div className="relative">
//               <input
//                 type="email"
//                 name="email"
//                 className="block w-full px-3 py-2 pr-28 border border-gray-300 rounded-md text-sm"
//                 placeholder="your@email.com"
//                 value={signUpData.email}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={handleSendCode}
//                 disabled={isCodeSent}
//                 className="absolute top-1/2 right-0 h-full transform -translate-y-1/2 bg-[#06513D] text-white text-xs w-[5.5rem] px-3 py-1 rounded-md"
//               >
//                 {isCodeSent ? "Code Sent" : "Send Code"}
//               </button>
//             </div>
//           </div>

//           {/* OTP */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Verification Code
//             </label>
//             <div className="relative">
//               <input
//                 type={showOTP ? "text" : "password"}
//                 name="otp"
//                 className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
//                 placeholder="••••••••"
//                 value={signUpData.otp}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={handleVerifyOtp}
//                 disabled={isVerifyingOtp || isOtpVerified}
//                 className={`absolute top-1/2 right-0 h-full transform -translate-y-1/2 text-white text-xs px-5 w-[5.5rem] py-1 rounded-md ${isOtpVerified
//                     ? 'bg-[#06513D]'
//                     : isVerifyingOtp
//                       ? 'bg-gray-400'
//                       : 'bg-[#06513D]'
//                   }`}
//               >
//                 {isOtpVerified
//                   ? "Verified"
//                   : isVerifyingOtp
//                     ? "Verifying..."
//                     : "Verify"
//                 }
//               </button>
//             </div>
//           </div>

//           {/* Password */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Password
//             </label>
//             <div className="relative">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
//                 placeholder="••••••••"
//                 value={signUpData.password}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 className="absolute inset-y-0 right-0 pr-3 flex items-center"
//               >
//                 {showPassword ? (
//                   <EyeOff className="h-4 w-4 text-gray-400" />
//                 ) : (
//                   <Eye className="h-4 w-4 text-gray-400" />
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Retype Password */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Retype Password
//             </label>
//             <div className="relative">
//               <input
//                 type={showRetypePassword ? "text" : "password"}
//                 name="retypePassword"
//                 className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
//                 placeholder="••••••••"
//                 value={signUpData.retypePassword}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowRetypePassword(!showRetypePassword)}
//                 className="absolute inset-y-0 right-0 pr-3 flex items-center"
//               >
//                 {showRetypePassword ? (
//                   <EyeOff className="h-4 w-4 text-gray-400" />
//                 ) : (
//                   <Eye className="h-4 w-4 text-gray-400" />
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Terms */}
//           <div className="flex items-center text-xs text-gray-700">
//             <input
//               type="checkbox"
//               className="h-4 w-4 text-green-600 mr-2"
//               checked={acceptAllTerms}
//               onChange={(e) => setAcceptAllTerms(e.target.checked)}
//             />
//             Accept{" "}
//             <span className="ml-1 text-[#06513D]">
//               Term & Condition, Policies & terms of use
//             </span>
//           </div>

//           {/* Submit */}
//           <div>
//             <button
//               type="submit"
//               className="w-full py-2 mt-4 px-4 bg-[#06513D] text-white rounded-md shadow text-sm"
//             >
//               Sign Up
//             </button>
//           </div>
//         </form>

//         <div className="mt-6 text-center">
//           <p className="text-sm text-gray-600">
//             Already have an account?{" "}
//             <button onClick={onLogin} className="font-medium text-[#06513D]">
//               Sign in
//             </button>
//           </p>
//         </div>
//       </div>

//       {/* Popup */}
//       {showPopup && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//           <PopupCard
//             type={popupData.type}
//             title={popupData.title}
//             message={popupData.message}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default SignupC;

import React, { useState } from "react";
import { Eye, EyeOff, X, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { API_URLS } from "../../api/apiUrls";
import { postApi } from "../../api/api_instance";
import { toast } from "react-hot-toast";
import PopupCard from "./PopupCard";
import { loginAsOrganisation, logout } from "../../redux/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";

const SignupC = ({ onCloseSignupC, onLogin }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signUpData, setSignUpData] = useState({
    name: "",
    email: "",
    password: "",
    otp: "",
    retypePassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [acceptAllTerms, setAcceptAllTerms] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignUpData({ ...signUpData, [name]: value });
  };

  const handleSendCode = async () => {
    if (!signUpData.email) {
      return triggerPopup("error", "Error", "Please enter your email first");
    }

    try {
      const response = await postApi({
        apiUrl: API_URLS.OTP_EMAIL,
        data: { email: signUpData.email },
      });

      if (response.success) {
        triggerPopup(
          "success",
          "Success",
          "Verification code sent to your email!",
        );
        setIsCodeSent(true);
      } else {
        triggerPopup(
          "error",
          "Error",
          response.message || "Failed to send code.",
        );
      }
    } catch (error) {
      triggerPopup("error", "Error", "Failed to send verification code.");
    }
  };

  // Password validation checks
  const getPasswordStrength = (password) => {
    return {
      minLength: password.length >= 8,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasNumbers: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
  };

  // Strong password validation function
  const validatePassword = (password) => {
    const checks = getPasswordStrength(password);

    if (!checks.minLength) {
      return "Password must be at least 8 characters long.";
    }
    if (!checks.hasUpperCase) {
      return "Password must contain at least one uppercase letter.";
    }
    if (!checks.hasLowerCase) {
      return "Password must contain at least one lowercase letter.";
    }
    if (!checks.hasNumbers) {
      return "Password must contain at least one number.";
    }
    if (!checks.hasSpecialChar) {
      return "Password must contain at least one special character (@, #, $, %, etc.).";
    }
    return null; // Password is valid
  };

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (!signUpData.name.trim()) {
      return triggerPopup(
        "error",
        "Error",
        "Please enter your organisation name.",
      );
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(signUpData.email)) {
      return triggerPopup("error", "Error", "Please enter a valid email.");
    }

    // Strong password validation
    const passwordError = validatePassword(signUpData.password);
    if (passwordError) {
      return triggerPopup("error", "Error", passwordError);
    }

    if (signUpData.password !== signUpData.retypePassword) {
      return triggerPopup("error", "Error", "Passwords do not match.");
    }

    if (!signUpData.otp) {
      return triggerPopup("error", "Error", "Please enter the OTP.");
    }

    if (!acceptAllTerms) {
      return triggerPopup(
        "error",
        "Error",
        "Please accept the terms and conditions.",
      );
    }

    try {
      // First call signup API
      const response = await postApi({
        apiUrl: API_URLS.SIGN_UP_CLIENT,
        data: signUpData,
      });

      if (response.success) {
        triggerPopup("success", "Success", response.message);

        // After successful signup, automatically call login API
        try {
          const loginResponse = await postApi(
            {
              apiUrl: API_URLS.LOGIN_CLIENT,
              data: {
                email: signUpData.email,
                password: signUpData.password,
              },
            },
            false,
          );

          if (loginResponse.success) {
            const { user, token } = loginResponse.data;
            dispatch(loginAsOrganisation({ user, token }));
            Modal.success({
              icon: null,
              centered: true,
              closable: false,
              className: "custom-success-modal",
              okButtonProps: { style: { display: "none" } },
              content: (
                <div className="flex flex-col items-center text-center -mt-6 -mx-6 -mb-6">
                  {/* Green Header */}
                  <div className="w-full bg-[#06513D] px-6 py-3 text-white text-center font-semibold text-lg">
                    Welcome To Carburn!
                  </div>

                  {/* Modal Body */}
                  <div className="w-full bg-white  py-4">
                    <div className="bg-[#06513D] p-3 rounded-full mx-auto w-fit mb-6">
                      <CheckOutlined
                        style={{ fontSize: "40px", color: "white" }}
                      />
                    </div>
                    <p className="text-[#06513D] text-base mb-6 font-medium">
                      Empowering your Net Zero journey
                    </p>
                  </div>
                </div>
              ),
            });
            navigate("/organization/dashboard");

            setTimeout(() => {
              Modal.destroyAll(); // Close all modals
            }, 2000);
          } else {
            // Handle case when login response.success is false
            toast.error(loginResponse.message || "Login failed after signup");
          }
        } catch (loginError) {
          // Handle login API error
          toast.error(
            "Signup successful but login failed. Please login manually.",
          );
        }
      } else {
        // Check if the error is specifically about incorrect OTP
        if (response.message === "Incorrect OTP") {
          triggerPopup(
            "error",
            "Invalid Code",
            "The verification code you entered is incorrect",
          );
        } else {
          // For other errors, use the original message
          triggerPopup("error", "Error", response.message || "Sign up failed.");
        }
      }
    } catch (error) {
      triggerPopup("error", "Error", "Sign up failed. Please try again.");
    }
  };

  const passwordStrength = getPasswordStrength(signUpData.password);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white py-4 px-6 shadow-lg rounded-lg sm:px-10 w-full max-w-md relative max-h-[100vh] ">
        <button
          onClick={onCloseSignupC}
          className="absolute right-3 top-3 text-gray-500 hover:text-gray-700"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-center text-2xl font-bold text-[#06513D] mb-1">
          CARBURN
        </h2>
        <p className="text-center text-sm text-gray-600 mb-2">
          Carbon Footprint & ESG Reporting
        </p>

        <form className="space-y-2" onSubmit={handleSignUp}>
          {/* Organisation Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Organisation Name
            </label>
            <input
              type="text"
              name="name"
              className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
              placeholder="Enter organisation name"
              value={signUpData.name}
              onChange={handleChange}
            />
          </div>

          {/* Email and Send Code */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <div className="relative">
              <input
                type="email"
                name="email"
                className="block w-full px-3 py-2 pr-28 border border-gray-300 rounded-md text-sm"
                placeholder="your@email.com"
                value={signUpData.email}
                onChange={handleChange}
              />
              <button
                type="button"
                onClick={handleSendCode}
                disabled={isCodeSent}
                className="absolute top-1/2 right-0 h-full transform -translate-y-1/2 bg-[#06513D] text-white text-xs w-[5.5rem] px-3 py-1 rounded-md"
              >
                {isCodeSent ? "Code Sent" : "Send Code"}
              </button>
            </div>
          </div>

          {/* OTP */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Verification Code
            </label>
            <div className="relative">
              <input
                type={showOTP ? "text" : "password"}
                name="otp"
                className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
                placeholder="••••••••"
                value={signUpData.otp}
                onChange={handleChange}
              />
              <button
                type="button"
                onClick={() => setShowOTP(!showOTP)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {showOTP ? (
                  <EyeOff className="h-4 w-4 text-gray-400" />
                ) : (
                  <Eye className="h-4 w-4 text-gray-400" />
                )}
              </button>
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
                placeholder="••••••••"
                value={signUpData.password}
                onChange={handleChange}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {showPassword ? (
                  <EyeOff className="h-4 w-4 text-gray-400" />
                ) : (
                  <Eye className="h-4 w-4 text-gray-400" />
                )}
              </button>
            </div>

            {/* Password Strength Indicator */}
            {signUpData.password && (
              <div className="mt-0.5 space-y-0">
                <div className="flex items-center text-[0.6rem]">
                  <div
                    className={`w-2 h-2 rounded-full mr-2 flex items-center justify-center ${passwordStrength.minLength ? "bg-[#06513D]" : "bg-gray-300"}`}
                  >
                    {passwordStrength.minLength && (
                      <Check className="w-2 h-2 text-white" />
                    )}
                  </div>
                  <span
                    className={
                      passwordStrength.minLength
                        ? "text-[#06513D]"
                        : "text-gray-500"
                    }
                  >
                    At least 8 characters
                  </span>
                </div>

                <div className="flex items-center text-[0.6rem]">
                  <div
                    className={`w-2 h-2 rounded-full mr-2 flex items-center justify-center ${passwordStrength.hasUpperCase ? "bg-[#06513D]" : "bg-gray-300"}`}
                  >
                    {passwordStrength.hasUpperCase && (
                      <Check className="w-2 h-2 text-white" />
                    )}
                  </div>
                  <span
                    className={
                      passwordStrength.hasUpperCase
                        ? "text-[#06513D]"
                        : "text-gray-500"
                    }
                  >
                    One uppercase letter
                  </span>
                </div>

                <div className="flex items-center text-[0.6rem]">
                  <div
                    className={`w-2 h-2 rounded-full mr-2 flex items-center justify-center ${passwordStrength.hasLowerCase ? "bg-[#06513D]" : "bg-gray-300"}`}
                  >
                    {passwordStrength.hasLowerCase && (
                      <Check className="w-2 h-2 text-white" />
                    )}
                  </div>
                  <span
                    className={
                      passwordStrength.hasLowerCase
                        ? "text-[#06513D]"
                        : "text-gray-500"
                    }
                  >
                    One lowercase letter
                  </span>
                </div>

                <div className="flex items-center text-[0.6rem]">
                  <div
                    className={`w-2 h-2 rounded-full mr-2 flex items-center justify-center ${passwordStrength.hasNumbers ? "bg-[#06513D]" : "bg-gray-300"}`}
                  >
                    {passwordStrength.hasNumbers && (
                      <Check className="w-2 h-2 text-white" />
                    )}
                  </div>
                  <span
                    className={
                      passwordStrength.hasNumbers
                        ? "text-[#06513D]"
                        : "text-gray-500"
                    }
                  >
                    One number
                  </span>
                </div>

                <div className="flex items-center text-[0.6rem]">
                  <div
                    className={`w-2 h-2 rounded-full mr-2 flex items-center justify-center ${passwordStrength.hasSpecialChar ? "bg-[#06513D]" : "bg-gray-300"}`}
                  >
                    {passwordStrength.hasSpecialChar && (
                      <Check className="w-2 h-2 text-white" />
                    )}
                  </div>
                  <span
                    className={
                      passwordStrength.hasSpecialChar
                        ? "text-[#06513D]"
                        : "text-gray-500"
                    }
                  >
                    One special character (@, #, $, etc.)
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* Retype Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Retype Password
            </label>
            <div className="relative">
              <input
                type={showRetypePassword ? "text" : "password"}
                name="retypePassword"
                className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm"
                placeholder="••••••••"
                value={signUpData.retypePassword}
                onChange={handleChange}
              />
              <button
                type="button"
                onClick={() => setShowRetypePassword(!showRetypePassword)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {showRetypePassword ? (
                  <EyeOff className="h-4 w-4 text-gray-400" />
                ) : (
                  <Eye className="h-4 w-4 text-gray-400" />
                )}
              </button>
            </div>
          </div>

          {/* Terms */}
          <div className="flex items-center text-xs text-gray-700">
            {/* <input
              type="checkbox"
              className="h-4 w-4 bg-[#06513D] mr-2"
              checked={acceptAllTerms}
              onChange={(e) => setAcceptAllTerms(e.target.checked)}
            /> */}
            <input
              type="checkbox"
              className="h-4 w-4 mr-2"
              style={{ accentColor: "#06513D" }}
              checked={acceptAllTerms}
              onChange={(e) => setAcceptAllTerms(e.target.checked)}
            />
            Accept{" "}
            <a
              href="/policies"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-1 text-[#06513D] hover:text-[#387464] hover:underline cursor-pointer"
            >
              Term & Condition, Policies & terms of use
            </a>
          </div>

          {/* Submit */}
          <div>
            <button
              type="submit"
              className="w-full py-2 mt-4 px-4 bg-[#06513D] text-white rounded-md shadow text-sm"
            >
              Sign Up
            </button>
          </div>
        </form>

        <div className="mt-3 text-center">
          <p className="text-sm text-gray-600">
            Already have an account?{" "}
            <button onClick={onLogin} className="font-medium text-[#06513D]">
              Sign in
            </button>
          </p>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}
    </div>
  );
};

export default SignupC;
